var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Precios de consultas","storeName":"Appointment_prices","parentStoreName":"Specialities","parentUrlKey":"speciality_id","canAdd":true,"canEdit":true,"canDelete":true,"labelAddNew":"Crear Nuevo","labelEdit":"Editar","labelDelete":"Eliminar","labelBack":"Atrás","sortable":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }